import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Modal from "../../../../components/Modal";
import { createStudentLevelList } from "../../studentSlice";
import CloseButton from "../../../../components/CloseButton";
import SelectedStudentList from "../../../../components/complex/SelectedStudentList";
import FilteredStudentList from "../../../../components/complex/FilteredStudentList";

const CreateStudentLevelModal = ({
  classStudents,
  setIsCreateModalOpen,
  editLevelId,
  levelName,
}) => {
  const dispatch = useDispatch();

  const { allStudents } = useSelector((state) => state.student);

  const [availableStudents] = useState(
    allStudents.filter(
      (student) => !classStudents.some((s) => s.id === student.id)
    )
  );
  const [filteredStudents, setFilteredStudents] = useState(availableStudents);
  const [selectedStudents, setSelectedStudents] = useState([]);

  const handleFilter = ({ keyword = "", gradeList = [], levelList = [] }) => {
    let studentList = availableStudents;

    if (keyword.trim() !== "") {
      studentList = studentList.filter((student) =>
        student.name.includes(keyword)
      );
    }

    studentList = studentList.filter((student) =>
      gradeList.includes(student.grade)
    );

    studentList = studentList.filter((student) =>
      levelList.some((level) => {
        if (level.id === 0) {
          return student.level_list.length === 0;
        }
        return student.level_list.some(
          (studentLevel) => studentLevel.id === level.id
        );
      })
    );

    setFilteredStudents(studentList);
  };

  // 좌측 체크박스 클릭 핸들러
  const handleSelectStudent = (student) => {
    if (selectedStudents.some((s) => s.id === student.id)) {
      setSelectedStudents((prev) => prev.filter((s) => s.id !== student.id));
    } else {
      setSelectedStudents((prev) => [...prev, student]);
    }
  };

  const handleSelectAllStudent = (checked, active = false) => {
    if (checked && active) {
      setSelectedStudents(filteredStudents);
    } else {
      setSelectedStudents([]);
    }
  };

  // 추가 버튼 클릭 핸들러
  const handleAddStudents = () => {
    dispatch(
      createStudentLevelList({
        studentIdList: selectedStudents.map((s) => s.id),
        levelId: editLevelId,
      })
    );
    alert(`${levelName}에 ${selectedStudents.length}명이 추가되었습니다.`);
    setSelectedStudents([]);
    setIsCreateModalOpen(false);
  };

  return (
    <Modal>
      <div
        style={{
          background: "#fff",
          padding: "10px 20px",
          borderRadius: "5px",
          width: "1200px",
          height: "600px",
          position: "relative",
          display: "flex",
          gap: "20px",
        }}
      >
        {/* 좌측 리스트 */}
        <div
          style={{
            flex: 3,
            borderRadius: "5px",
          }}
        >
          <p>
            <span
              style={{ fontSize: "18px", marginRight: "15px", color: "black" }}
            >
              학생 추가하기
            </span>
            <span style={{ fontSize: "16px" }}>{levelName}</span>
          </p>
          <FilteredStudentList
            filteredStudents={filteredStudents}
            selectedStudents={selectedStudents}
            handleSelectStudent={handleSelectStudent}
            handleSelectAllStudent={handleSelectAllStudent}
            handleFilter={handleFilter}
            levelId={editLevelId}
          />
        </div>

        {/* 우측 리스트 */}
        <div
          style={{
            flex: 1,
            borderRadius: "5px",
            padding: "10px",
          }}
        >
          {/* X 버튼 */}
          <CloseButton onClick={setIsCreateModalOpen} />

          <div
            style={{
              marginTop: "50px",
            }}
          >
            <SelectedStudentList
              selectedStudents={selectedStudents}
              handleAddStudents={() => handleAddStudents()}
              handleSelectAllStudent={handleSelectAllStudent}
              handleSelectStudent={handleSelectStudent}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CreateStudentLevelModal;
